import { render, staticRenderFns } from "./create-menu.vue?vue&type=template&id=17f9aa44&scoped=true&"
import script from "./create-menu.vue?vue&type=script&lang=js&"
export * from "./create-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9aa44",
  null
  
)

export default component.exports